import React from "react";
import { useSelector } from "react-redux";
import { meProducersSelector } from "../../helpers/Selectors";
import PropTypes from "prop-types";
import VideoView from "./Media/VideoView";
import PeerInfo from "./Media/PeerInfo";
import MediaBox from "../Presence/Media/MediaBox";
import RemoteControlHostActions from "../RemoteControl/RemoteControlHostActions";

const Me = ({
  style,
  showPeerInfo = true,
  onFilmStrip = false,
  mini = false,
  screenOnly = false,
}) => {
  const me = useSelector((state) => state.me);
  const settings = useSelector((state) => state.settings);
  const activeSpeakerId = useSelector((state) => state.room.activeSpeakerId);
  const isActiveSpeaker = me.id === activeSpeakerId;
  const { micProducer, webcamProducer, screenProducer } = useSelector((state) =>
    meProducersSelector(state)
  );
  const videoVisible =
    Boolean(webcamProducer) &&
    !webcamProducer.locallyPaused &&
    !webcamProducer.remotelyPaused;

  const screenVisible =
    Boolean(screenProducer) &&
    !screenProducer.locallyPaused &&
    !screenProducer.remotelyPaused;

  let micState;

  if (!me.canSendMic) {
    micState = "unsupported";
  } else if (!micProducer) {
    micState = "off";
  } else if (!micProducer.locallyPaused && !micProducer.remotelyPaused) {
    micState = "on";
  } else {
    micState = "muted";
  }

  return (
    <React.Fragment>
      {!screenOnly && (
        <MediaBox activeSpeaker={isActiveSpeaker} style={style} isMe>
          <PeerInfo
            peer={me}
            isMe={true}
            isScreen={false}
            displayName={settings.displayName}
            showPeerInfo={showPeerInfo}
            micOff={micState === "on" ? false : true}
            onFilmStrip={onFilmStrip}
            mini={mini}
          />

          <VideoView
            isMe
            peer={me}
            displayName={settings.displayName}
            videoTrack={webcamProducer && webcamProducer.track}
            videoVisible={videoVisible}
          />
        </MediaBox>
      )}
      {screenProducer && (
        <MediaBox style={style} isMe isScreen>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
              minHeight: 0,
              padding: "8px 10px 0",
              boxSizing: "border-box",
            }}
          >
            <RemoteControlHostActions />
            <div style={{ flex: "1 1 auto", minHeight: 0, position: "relative" }}>
              <PeerInfo
                peer={me}
                isMe={true}
                isScreen={true}
                mini={mini}
                displayName={settings.displayName}
                showPeerInfo={showPeerInfo}
                onFilmStrip={onFilmStrip}
              />

              <VideoView
                peer={me}
                isMe
                isScreen
                displayName={settings.displayName}
                videoContain
                videoTrack={screenProducer && screenProducer.track}
                videoVisible={screenVisible}
              />
            </div>
          </div>
        </MediaBox>
      )}
    </React.Fragment>
  );
};

Me.propTypes = {
  style: PropTypes.object,
  showPeerInfo: PropTypes.bool,
  onFilmStrip: PropTypes.bool,
  screenOnly: PropTypes.bool,
};

export default Me;
